import React from "react";
import logo from "./logo.svg";
import "./App.css";
import ReportRequestPage from "./reportRequestPage/reportRequestPage";

function App() {
  return <ReportRequestPage />;
}

export default App;
